import React, { useState, useEffect } from 'react';
import FeedbackService from '../../modules/services/Feedbackservice';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ptBR } from 'date-fns/locale';
import { format } from 'date-fns';
import '../css/boletos.css'; // Reutilizando CSS

function ConsultaFeedback({ cliente }) {
    const [feedbacks, setFeedbacks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtros, setFiltros] = useState({
        dataInicial: null,
        dataFinal: null
    });

    useEffect(() => {
        // Carrega últimos 30 dias ao abrir
        buscarFeedbacks();
    }, []);

    const buscarFeedbacks = async () => {
        setLoading(true);
        try {
            const dtIni = filtros.dataInicial ? format(filtros.dataInicial, 'dd/MM/yyyy') : null;
            const dtFim = filtros.dataFinal ? format(filtros.dataFinal, 'dd/MM/yyyy') : null;

            const response = await FeedbackService.consultarFeedbacks(cliente.cdCliente, dtIni, dtFim);
            if (response.status === 'OK') {
                setFeedbacks(response.conteudo);
            }
        } catch (error) {
            console.error("Erro ao buscar feedbacks", error);
        } finally {
            setLoading(false);
        }
    };

    const getNpsColor = (tipo) => {
        // 1: Detrator (Vermelho), 2: Neutro (Amarelo), 3: Promotor (Verde)
        // O backend retorna cdFeedbackTipo como número
        if (tipo === 1) return '#dc3545';
        if (tipo === 2) return '#ffc107';
        if (tipo === 3) return '#28a745';
        return '#6c757d';
    };

    return (
        <div className="dashboard-painel boletos-painel">
            <h3 className="titulo">Histórico de Feedbacks</h3>

            {/* FILTROS */}
            <div className="boletos-filtros">
                <DatePicker
                    selected={filtros.dataInicial}
                    onChange={(date) => setFiltros({ ...filtros, dataInicial: date })}
                    dateFormat="dd/MM/yyyy"
                    locale={ptBR}
                    placeholderText="Data Inicial"
                    className="input-filtro"
                />
                <DatePicker
                    selected={filtros.dataFinal}
                    onChange={(date) => setFiltros({ ...filtros, dataFinal: date })}
                    dateFormat="dd/MM/yyyy"
                    locale={ptBR}
                    placeholderText="Data Final"
                    className="input-filtro"
                />
                <button 
                    type="button" 
                    className="download-btn"
                    onClick={buscarFeedbacks}
                    disabled={loading}
                >
                    {loading ? 'Buscando...' : 'Filtrar'}
                </button>
            </div>

            {/* TABELA */}
            <div className="boletos-lista">
                <table className="boletos-tabela">
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Área</th>
                            <th>Nota</th>
                            <th>Seu Comentário</th>
                            <th>Resposta GAM</th>
                        </tr>
                    </thead>
                    <tbody>
                        {feedbacks.length > 0 ? (
                            feedbacks.map((item) => (
                                <tr key={item.sqFeedbackCliente}>
                                    <td>{item.dtGravacao}</td>
                                    <td>{item.dsFeedbackArea}</td>
                                    <td>
                                        <span style={{
                                            fontWeight: 'bold',
                                            color: getNpsColor(item.cdFeedbackTipo)
                                        }}>
                                            {item.vlAvaliacao}
                                        </span>
                                        <span style={{fontSize: '11px', color: '#888', marginLeft: '5px'}}>
                                            ({item.dsFeedbackTipo})
                                        </span>
                                    </td>
                                    <td style={{maxWidth: '300px'}}>{item.dsFeedbackCliente}</td>
                                    <td style={{maxWidth: '300px'}}>
                                        {item.dsSolucao ? (
                                            <>
                                                <div>{item.dsSolucao}</div>
                                                <small style={{color: '#888'}}>Em: {item.dtConclusao}</small>
                                            </>
                                        ) : (
                                            <span style={{fontStyle: 'italic', color: '#888'}}>Aguardando análise...</span>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" style={{textAlign: 'center', padding: '20px'}}>
                                    Nenhum feedback encontrado no período.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ConsultaFeedback;